export let ENTITY_TYPE = /*#__PURE__*/function (ENTITY_TYPE) {
  ENTITY_TYPE["CONTAINER"] = "CONTAINER";
  ENTITY_TYPE["USER"] = "USER";
  return ENTITY_TYPE;
}({});
export let CONTAINER_TYPE = /*#__PURE__*/function (CONTAINER_TYPE) {
  CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
  CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
  return CONTAINER_TYPE;
}({});